import Head from 'next/head';
import ForgotPasswordPage from '../../components/pages/ForgotPassword/ForgotPassword';
import { withPublicOnlyRoute } from '../../lib/auth/publicOnlyRoute';
import { withSessionSsr } from '../../lib/withSession';

export default function ForgotPassword() {
  return (
    <>
      <Head>
        <title>Dealer Portal - Forgot Password</title>
      </Head>
      <ForgotPasswordPage />
    </>
  );
}
export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
    return withPublicOnlyRoute(ctx, (ctx) => {
      return {
        props: {},
      };
    });
  }
);
